var map = {
	"./en-US.json": "./src/locales/en-US.json",
	"./notifications/en.json": "./src/locales/notifications/en.json",
	"./notifications/pl.json": "./src/locales/notifications/pl.json",
	"./notifications/ru.json": "./src/locales/notifications/ru.json",
	"./pl-PL.json": "./src/locales/pl-PL.json",
	"./ru-RU.json": "./src/locales/ru-RU.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$i";